import { useCallback, useEffect, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'

import { getAllStudents, SerializationContexts } from '../../../../utils/api/student'
import { selectUser } from '../../../../reducers/UserReducer'
import { retrieveMetadata } from '../../../../utils/http'
import { Alert } from 'antd'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import Loading from '../../Loading'
import StudentsSelector from './StudentsSelector'
import { castArray, compact, debounce, isString, uniqBy } from 'lodash'
import { StudentProperties } from '../../../../utils/entities/student'
import { URIEncode } from '../../../../utils/apiHelper'

const PAGE_SIZE = 100

const CONTEXTS = [SerializationContexts.SECTION]

const SEARCH_COLUMNS = [StudentProperties.LASTNAME, StudentProperties.FIRSTNAME, StudentProperties.EMAIL, StudentProperties.MATRICULE]

const searchParameters = search => {
  if (!isString(search) || search.trim() === '') {
    return {}
  }

  const value = URIEncode(search.trim())

  return { search: value, filters: { search: value, columns: SEARCH_COLUMNS } }
}

const AutoStudentsSelector = ({ disabled, placeholder, selected, style = {}, tagPlaceholder, values, onChange }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [students, setStudents] = useState({ data: [], metadata: null })

  const fecthStudents = useCallback(parameters => {
    setLoading(true)

    getAllStudents(user, parameters).then(({ data, meta }) => {
      setStudents({ data, metadata: retrieveMetadata(meta) })
    }).finally(() => setLoading(false))
  }, [user])

  useEffect(() => {
    const fetch = debounce(() => fecthStudents({ page: 1, pageSize: PAGE_SIZE, contexts: CONTEXTS, ...searchParameters(search) }), 500)

    fetch()

    return () => fetch.cancel()
  }, [fecthStudents, search])

  const options = useMemo(
    () => uniqBy(compact(castArray(selected)).concat(students.data), 'id'),
    [selected, students.data]
  )

  const renderDropdown = menu => (
    <div>
      {students.metadata?.totalPages > 1 && (
        <Alert
          className='more-message'
          message={t('form.request.institutions_count_more')}
          type='info'
          showIcon
          banner
        />
      )}
      {loading ? (<Loading loading={loading} style={{ height: '100px' }} />) : menu}
    </div>
  )

  return (
    <StudentsSelector
      disabled={disabled}
      multiple='default'
      placeholder={placeholder}
      style={style}
      students={options}
      dropdownRender={renderDropdown}
      tagPlaceholder={tagPlaceholder}
      values={values}
      showSearch
      loading={loading}
      onChange={onChange}
      onSearch={setSearch}
    />
  )
}

export default AutoStudentsSelector
